import React from "react";
import Episodes from "./EpisodeViewMore";
import Footer from "../common/UI/Footer";
import { useParams } from "react-router-dom";
import { useSeriesBySlug, useSimilarSeries } from "../hooks/useSeriesData";
import { useChaptersBySeriesId } from "../hooks/useChapters";
import Loading from "../common/HousGlass Loader/Loading";
import SeriesPlayScreen from "./SeriesPlayScreen";
import SimilarSeriesSection from "./SimilarSeriesSection";

const SeriesEpisode = () => {
  const { slug } = useParams();

  const {
    series,
    isLoading: isLoadingSeries,
    error: seriesError,
  } = useSeriesBySlug(slug);

  const {
    chapters,
    isLoading: isLoadingChapters,
    error: chaptersError,
  } = useChaptersBySeriesId(series?.id);

  const { series:data } = useSimilarSeries(series?.id);
  

  if (isLoadingSeries || isLoadingChapters) {
    return <Loading />;
  }

  if (seriesError) {
    return <div>Error loading series: {seriesError.message}</div>;
  }

  if (chaptersError) {
    return <div>Error loading chapters: {chaptersError.message}</div>;
  }

  return (
    <>
      <SeriesPlayScreen audioData={series} chapters={chapters} />
      <Episodes seriesId={series?.id} chapters={chapters} seriesData={series} />
      <SimilarSeriesSection similarSeries={data?.similarSeries} />
      <Footer />
    </>
  );
};

export default SeriesEpisode;
